import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Linkedin, Youtube, Instagram, ArrowRight } from 'lucide-react';
import { useCompany, useContent } from '../context/ContentContext';

export default function Footer() {
  const companyInfo = useCompany();
  const { products, site_content } = useContent();
  return (
    <footer className="footer mt-10">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="font-display text-lg text-white mb-4 uppercase tracking-wider relative pb-2 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-10 after:h-[2px] after:bg-[#f7941e]">About Us</h3>
          <p className="text-sm text-gray-400 leading-relaxed">
            {site_content?.footer_about_text || 'Ess Bee Heaters Pvt. Ltd. is a leading manufacturer and pioneer in the field of Domestic and Industrial Heating Elements.'}
          </p>
          <div className="flex items-center gap-2 mt-4">
            <a href={companyInfo.socials.facebook} className="w-8 h-8 rounded bg-[#2a2a2a] flex items-center justify-center hover:bg-[#f7941e] transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href={companyInfo.socials.linkedin} className="w-8 h-8 rounded bg-[#2a2a2a] flex items-center justify-center hover:bg-[#f7941e] transition-colors"><Linkedin className="w-4 h-4" /></a>
            <a href={companyInfo.socials.youtube} className="w-8 h-8 rounded bg-[#2a2a2a] flex items-center justify-center hover:bg-[#f7941e] transition-colors"><Youtube className="w-4 h-4" /></a>
            <a href={companyInfo.socials.instagram} className="w-8 h-8 rounded bg-[#2a2a2a] flex items-center justify-center hover:bg-[#f7941e] transition-colors"><Instagram className="w-4 h-4" /></a>
          </div>
        </div>
        <div>
          <h3 className="font-display text-lg text-white mb-4 uppercase tracking-wider relative pb-2 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-10 after:h-[2px] after:bg-[#f7941e]">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {['/', '/about', '/products', '/gallery', '/contact'].map((p, i) => {
              const labels = ['Home','About Us','Products','Gallery','Contact Us'];
              return (
                <li key={p}><Link to={p} className="text-gray-400 hover:text-[#f7941e] flex items-center gap-1 transition-colors"><ArrowRight className="w-3 h-3" />{labels[i]}</Link></li>
              );
            })}
          </ul>
        </div>
        <div>
          <h3 className="font-display text-lg text-white mb-4 uppercase tracking-wider relative pb-2 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-10 after:h-[2px] after:bg-[#f7941e]">Top Products</h3>
          <ul className="space-y-2 text-sm">
            {products.slice(0, 6).map(p => (
              <li key={p.slug}><Link to={`/products/${p.slug}`} className="text-gray-400 hover:text-[#f7941e] flex items-center gap-1 transition-colors"><ArrowRight className="w-3 h-3" />{p.name}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-display text-lg text-white mb-4 uppercase tracking-wider relative pb-2 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-10 after:h-[2px] after:bg-[#f7941e]">Contact Info</h3>
          <ul className="space-y-3 text-sm text-gray-400">
            <li className="flex gap-2"><MapPin className="w-4 h-4 text-[#f7941e] shrink-0 mt-0.5" /><span>{companyInfo.address}</span></li>
            {companyInfo.contacts.map((c) => (
              <li key={c.phone} className="flex gap-2"><Phone className="w-4 h-4 text-[#f7941e] shrink-0 mt-0.5" />
                <span><span className="text-white block text-xs uppercase tracking-wide">{c.name}</span><a href={`tel:${c.phone}`} className="hover:text-[#f7941e]">{c.phone}</a></span>
              </li>
            ))}
            {(companyInfo.email || []).map((e) => (
              <li key={e} className="flex gap-2"><Mail className="w-4 h-4 text-[#f7941e] shrink-0 mt-0.5" /><a href={`mailto:${e}`} className="hover:text-[#f7941e] break-all">{e}</a></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2a2a2a] py-4">
        <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} {companyInfo.name || 'Ess Bee Heaters Pvt. Ltd.'}. All Rights Reserved.</p>
          <p>{site_content?.footer_copyright_suffix || 'Made by Hrithik Bansal'}</p>
        </div>
      </div>
    </footer>
  );
}
